import { HelpCircleIcon } from 'lucide-react'

import { RENEWAL_EVENTS, useEmitEmployerRenewalsEvent } from 'apps/employer_renewals/events'
import { TextLink } from 'slab'

const SUPPORT_LINK = 'https://support.thatch.com/oep-2026-employer-guide'

export function SupportButton () {
  const { emitEvent } = useEmitEmployerRenewalsEvent()

  const onClick = () => {
    emitEvent(RENEWAL_EVENTS.SUPPORT_LINK_CLICKED, {
      url: window.location.href,
    })
  }

  return (
    <TextLink
      href={SUPPORT_LINK}
      target='_blank'
      rel='noopener noreferrer'
      onClick={onClick}
      leftIcon={HelpCircleIcon}
    >
      Get support
    </TextLink>
  )
}
